export default "__VITE_ASSET__BPB8FWJH__"